import styled from "styled-components";

const Label = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSubtle};
  text-align: left;
`;

const ContentContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  min-height: 24px;
  display: flex;
  align-items: center;
`;

interface CellLayoutProps {
   children?: import('react').ReactNode; label?: string;
}

const CellLayout: React.FC<React.PropsWithChildren<CellLayoutProps>> = ({ label = "", children }) => {
  return (
    <div>
      {label !== "Multiplier" && label && <Label>{label}</Label>}
      <ContentContainer>{children}</ContentContainer>
    </div>
  );
};

export default CellLayout;
